



















































import Gravatar from 'vue-gravatar'
import { Auth } from 'aws-amplify'

import UserRole from '@/contexts/auth/UserRole.vue'
import AdminOnly from '@/contexts/auth/AdminOnly.vue'

export default {
  components: {
    gravatar: Gravatar,
    'user-role': UserRole,
    'admin-only': AdminOnly
  },
  data: function() {
    return {
      profileMenuShown: false,
      documentClickedOff: false,
      email: '',
      name: ''
    }
  },
  watch: {
    '$store.state.clientId': function() {
      this.getEmail()
    }
  },
  mounted() {
    this.getEmail()
    document.body.addEventListener(
      'click',
      () => {
        this.documentClickedOff = this.profileMenuShown
        this.profileMenuShown = false
      },
      true
    )
  },
  methods: {
    signOut() {
      return Auth.signOut({ global: true })
        .then(() => this.$store.commit('setClientId', undefined))
        .then(() => localStorage.clear())
    },
    getEmail: function() {
      Auth.currentAuthenticatedUser().then(user => {
        this.email = user.attributes.email
        this.name = user.attributes['custom:name']
      })
    },

    toggleProfileMenu() {
      if (!this.documentClickedOff) {
        this.profileMenuShown = !this.profileMenuShown
      }
      this.documentClickedOff = false
    }
  }
}
